import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import { history } from '../../helpers';
import InsightComponent from './Insights/InsightComponent.js'
import '../../content/css/PortfolioAnalysis/PortfolioAnalysis.css';
import DocumentsTable from './DocumentsTable.js';
import { PrivateRoute } from '../../components/PrivateRoute';

export default class PortfolioAnalysisInsights extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: "",
            insights: {},
            selectedInsightDocuments: []
        }
    }

    componentDidMount() {
        const selectedType = this.getLastUrlSegment(document.URL);
        if (selectedType !== "" && selectedType !== 'insights') this.setState({ selected: selectedType });
        this.updateData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.insights !== this.props.insights) {
            this.updateData();
        }

        if (this.state.selected !== prevState.selected) {
            this.updateDocuments();
        }
    }

    getLastUrlSegment = (url) => {
        const segments = new URL(url).pathname.split('/');
        const last = segments.pop() || segments.pop(); // Handle potential trailing slash
        return last;
    }

    updateData = () => {
        this.setState({ insights: this.props.insights });
    }

    updateDocuments = () => {
        let selectedInsight = Object.entries(this.state.insights).filter(([type, x]) => x.type === this.state.selected)[0];
        let documents = [...this.props.documents];
        for (const doc of documents) {
            let highlightIndex = doc.highlightIndexes[selectedInsight[1].categoryCode];
            highlightIndex = highlightIndex ? highlightIndex : (selectedInsight[1].data[doc.id] ? selectedInsight[1].data[doc.id][0] : 0)
            doc.highlightIndex = highlightIndex;
        }

        this.setState({ insights: this.props.insights, documents });
    }

    handleSelect = (type) => {
        this.setState({ selected: type });

        let url = this.props.match.url;
        if (type !== "") url += `/${type}`;

        history.push(url);
    }

    renderInsights = () => {
        let insights = Object.entries(this.state.insights);
        return insights.map(([type, item], index) => {
            return <InsightComponent
                key={index}
                title={item.title}
                type={item.type}
                description={item.description}
                playbookText={item.playbookText}
                data={item.values}
                isSelected={false}
                filter={this.props.filter.governingLaws}
                onSelect={this.handleSelect} />
        });
    }

    renderSelectedInsight = () => {
        let items = Object.entries(this.state.insights).filter(([type, x]) => x.type === this.state.selected);
        if (items == null || items.length === 0)
            return;

        let item = items[0][1];
        return <InsightComponent
            key={0}
            title={item.title}
            type={item.type}
            description={item.description}
            playbookText={item.playbookText}
            data={item.values}
            isSelected={true}
            filter={this.props.filter.governingLaws}
            onSelect={this.handleSelect} />;
    }

    getExtraColumnData = () => {
        let items = Object.entries(this.state.insights).filter(([type, x]) => x.type === this.state.selected);
        if (items == null || items.length === 0)
            return;

        let item = items[0][1];
        let data = this.getDefaultExtraColumnDataForInsight(item);
        if (item.type === "MultiConfidentiality") {
            data = this.getExtraColumnDataForMultiConfidentialityInsight(item);
        }
        else if (item.type === "MultiTermination") {
            data = this.getExtraColumnDataForMultiConfidentialityInsight(item);
        }
        return data;
    }

    getExtraColumnDataForMultiConfidentialityInsight = (insight) => {
        let groups = this.groupBy(insight.values, 'documentId');
        let data = Object.entries(groups).map(([documentId, items]) => {
            const uniqueLabels = new Set(items.map(item => item.code));
            return uniqueLabels.size;
        });
        return data;
    }

    getDefaultExtraColumnDataForInsight = (insight) => {
        let groups = this.groupBy(insight.values, 'documentId');
        let data = Object.entries(groups).map(([documentId, items]) => {
            const uniqueLabels = new Set();
            return items.reduce((acc, item) => {
                if (!uniqueLabels.has(item.label)) {
                    uniqueLabels.add(item.label);
                    return acc ? acc + ', ' + item.label : item.label;
                }
                return acc;
            }, '')
        });
        return data;
    }

    groupBy = (items, key) => {
        return items.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    render() {
        let path = this.props.match ? this.props.match.path : "";
        let forOneflow = path.includes("workspace");
        return (
            <div>
                <PrivateRoute path={`${path}/:type`} component={(props) => (
                    <React.Fragment>
                        {this.renderSelectedInsight()}
                        <Panel>
                            <DocumentsTable
                                basePathForLinks={forOneflow ? '/workspace' : '/reports'}
                                reportId={this.props.reportId}
                                items={this.props.documents}
                                extraColumnTitle={this.state.selected}
                                extraColumnData={this.getExtraColumnData()}
                                hideContractType={this.props.hideContractType}
                            />
                        </Panel>
                    </React.Fragment>
                )}
                />
                <PrivateRoute exact path={path} component={(props) => (
                    <React.Fragment>
                        {this.renderInsights()}
                    </React.Fragment>
                )}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AnalysisReports/PortfolioAnalysisInsights.js